import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=fbf4916c&scoped=true"
import script from "./ReservationList.vue?vue&type=script&lang=js"
export * from "./ReservationList.vue?vue&type=script&lang=js"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=fbf4916c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf4916c",
  null
  
)

export default component.exports